import { gql } from "@apollo/client";

export const GET_STACK_RUN_TRACE_DOWNLOAD_URL = gql`
  query GetStackRunTraceDownloadURL($stackId: ID!, $runId: ID!) {
    stack(id: $stackId) {
      id
      run(id: $runId) {
        id
        otelTraceForJaegerDownloadURL {
          url
        }
      }
    }
  }
`;
